export default {"src":"/_next/static/media/circleQuestionMark_24.77c30c99.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};